import { i18n } from "@/config/i18n";
import tradeLogs from "@/data/trade-logs.json";

export default {
  name: 'ShcSignal',
  data() {
    return {
      machineSteps: [
        { titleKey: 'home.SignalStep1Title', descKey: 'home.SignalStep1Desc', tags: ['EXNESS', 'VANTAGE', 'Pu Prime', 'TVSI'] },
        { titleKey: 'home.SignalStep2Title', descKey: 'home.SignalStep2Desc', tags: ['CONSERVATIVE', 'BALANCED', 'GROWTH'] },
        { titleKey: 'home.SignalStep3Title', descKey: 'home.SignalStep3Desc', tags: ['AUTO-TRADE', 'RISK MANAGEMENT'] },
        { titleKey: 'home.SignalStep4Title', descKey: 'home.SignalStep4Desc', tags: ['REAL-TIME', 'TRANSPARENT', 'FLEXIBLE'] },
      ],
      tradeLogs,
    };
  },
  computed: {
    tradeChart() {
      const toMin = t => {
        const [h, m] = t.split(':').map(Number);
        return h * 60 + m;
      };
      const sorted = [...tradeLogs].sort((a, b) => toMin(a.time) - toMin(b.time));
      const totalProfit  = sorted.reduce((s, t) => s + t.profit, 0);
      const wins         = sorted.filter(t => t.profit > 0).length;
      const total        = sorted.length;
      const maxAbsProfit = Math.max(...sorted.map(t => Math.abs(t.profit)));

      const sparkW = 600, sparkH = 48, padS = 4;
      const times  = sorted.map(t => toMin(t.time));
      const minT   = Math.floor((times[0] - 10) / 30) * 30;
      const maxT   = Math.ceil((times[times.length - 1] + 10) / 30) * 30;
      const rangeT = maxT - minT;

      let cum = 0;
      const cumPoints = [{ min: minT, cum: 0 }];
      sorted.forEach(t => { cum += t.profit; cumPoints.push({ min: toMin(t.time), cum }); });

      const maxCum = Math.max(...cumPoints.map(p => p.cum));
      const minCum = Math.min(0, Math.min(...cumPoints.map(p => p.cum)));
      const rangeC = (maxCum - minCum) || 1;

      const sx = min => padS + ((min - minT) / rangeT) * (sparkW - padS * 2);
      const sy = c   => sparkH - padS - ((c - minCum) / rangeC) * (sparkH - padS * 2);

      const sparkPts = cumPoints.map(p => `${sx(p.min).toFixed(1)},${sy(p.cum).toFixed(1)}`).join(' ');
      const firstX = sx(cumPoints[0].min).toFixed(1);
      const lastX  = sx(cumPoints[cumPoints.length - 1].min).toFixed(1);
      const baseY  = (sparkH - padS).toFixed(1);
      const sparkFill = `M ${firstX},${baseY} L ${sparkPts.replace(/(\d+\.\d+),(\d+\.\d+)/g, '$1,$2')} L ${lastX},${baseY} Z`;

      const timeGrid = [];
      for (let m = minT; m <= maxT; m += 30) {
        const hh = String(Math.floor(m / 60)).padStart(2, '0');
        const mm = String(m % 60).padStart(2, '0');
        timeGrid.push({ label: `${hh}:${mm}`, isHour: m % 60 === 0, pct: ((m - minT) / rangeT * 100).toFixed(1) });
      }

      return {
        sorted, total, wins,
        winRate:      Math.round(wins / total * 100),
        totalProfit:  totalProfit.toFixed(2),
        maxAbsProfit,
        sparkW, sparkH,
        sparkLine:    sparkPts,
        sparkFill,
        sparkZeroY:   sy(0).toFixed(1),
        timeGrid,
      };
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    t(key) { return i18n.global.t(key); },
    goToContact() { this.$router.push('/contact'); },
  },
};
